export const toggleUsernameElements = (username) => {
  document.querySelectorAll(`[data-username='${username}']`).forEach($el => {
    $el.classList.add($el.dataset.usernameClass);
  });
}
